/**
 * Globale Progressive-Enhancement-Helfer.
 * Alles hier ist optional — ohne JS bleibt jede Seite voll les- und bedienbar.
 */
(function () {
  'use strict';

  /* Scroll-Reveal für Elemente mit .rv (html.js-Gate sitzt im Head) */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealed = document.querySelectorAll('.rv');
  if (revealed.length && 'IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    revealed.forEach(function (el) {
      io.observe(el);
    });
  } else {
    revealed.forEach(function (el) {
      el.classList.add('in');
    });
  }

  /* Toast: window.mediairToast('Nachricht') */
  var toastEl = null;
  var toastTimer = null;
  window.mediairToast = function (message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('show');
    }, 3200);
  };
})();
